import { render } from "./PackageOrder.vue?vue&type=template&id=697ea85c"
import script from "./PackageOrder.vue?vue&type=script&lang=js"
export * from "./PackageOrder.vue?vue&type=script&lang=js"

import "./PackageOrder.vue?vue&type=style&index=0&id=697ea85c&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__